export default __webpack_public_path__ + "static/media/plus_white.469bc8eb.svg";